import type { PublishingGeometry } from "./document";

export function resolvePageBoxes(
  geometry: PublishingGeometry,
  side: "left" | "right",
) {
  const { trim, bleed, slug, margins } = geometry;
  const x = slug.left + bleed.left,
    y = slug.top + bleed.top;
  const marginLeft = side === "left" ? margins.outer : margins.inner;
  const marginRight = side === "left" ? margins.inner : margins.outer;
  return {
    media: {
      x: 0,
      y: 0,
      width: x + trim.width + bleed.right + slug.right,
      height: y + trim.height + bleed.bottom + slug.bottom,
    },
    trim: { x, y, ...trim },
    bleed: {
      x: slug.left,
      y: slug.top,
      width: trim.width + bleed.left + bleed.right,
      height: trim.height + bleed.top + bleed.bottom,
    },
    content: {
      x: x + marginLeft,
      y: y + margins.top,
      width: trim.width - marginLeft - marginRight,
      height: trim.height - margins.top - margins.bottom,
    },
  };
}
